<script setup>
import { DEV_MODE } from '@/config/dev-mode';
import { useAnalysisStore } from '@/store/modules/analysis';
import { addContentLogAPI } from '@/api/logServiceApi';
import { calculateDDay } from '@/utils/dateFormatter';
/* icon */
import IconArrow08 from '@/components/svg/IconArrow08.vue';

const analysisStore = useAnalysisStore();

const props = defineProps({
  ticketCountData: {
    required: true,
  },
  yongsinLogData: {
    required: true,
  },
  hasPermission: {
    required: true,
  },
  loadingTicket: {
    required: true,
  },
});

const emit = defineEmits(['goPopAnalysis']);

const yongsinLogData = computed(() => {
  if (!props.yongsinLogData?.length) return null;
  const yonsinData = props.yongsinLogData[0];
  return yonsinData;
});

const dDay = computed(() => calculateDDay(yongsinLogData.value?.expiryDate));

/** 목차 리스트 */
const yongsinContentList = [
  {
    label: '📖 용신분석 안내서 - 사주 해석의 중심축을 잡아주는 나침반',
    view: '/youngsin/guide',
  },
  {
    label: '1. 종합분석',
    view: '/youngsin/content',
  },
  { label: '2. 격국분석', view: '/youngsin/content' },
  { label: '3. 격국패턴', view: '/youngsin/content' },
  { label: '4. 음양분석', view: '/youngsin/content' },
  { label: '5. 조후분석', view: '/youngsin/content' },
  { label: '6. 신강/신약', view: '/youngsin/content' },
  { label: '7. 인공지능 용신 분석', view: '/youngsin/content' },
  { label: '8. 용/희/기/구/한', view: '/youngsin/content' },
  { label: '9. 선정용신', view: '/youngsin/content' },
  { label: '10. 대운흐름', view: '/youngsin/content' },
  { label: '11. 용신과 희신 잘 활용하는 법', view: '/youngsin/content' },
];

const goPopAnalysis = () => emit('goPopAnalysis');

/** 목차 이동 */
const goToChildMenu = (contentIdx) => {
  addContentLogAPI({
    contentType: props.hasPermission ? 'ay_yongsin_toc_paid_opt3' : 'ay_yongsin_toc_free_opt3',
    option3: String(contentIdx),
  });

  if (contentIdx >= 1 && !props.hasPermission) {
    goPopAnalysis();
    return;
  }
  analysisStore.navigateToContent('/youngsin', contentIdx);
  DEV_MODE && console.log('목차 이동', contentIdx);
};
</script>

<template>
  <div class="si-overview si-overview--yongsin">
    <div class="si-overview__cover">
      <div class="si-overview__cover-inner">
        <div class="si-overview__header">
          <div class="si-overview__title">
            <div class="si-overview__name">
              <span class="si-overview__name-text">{{ analysisStore.userName || '-' }}</span>
              <span class="si-overview__name-suffix">님의</span>
            </div>
            <div class="si-overview__service">낭만 용신분석</div>
          </div>
          <div class="si-overview__badge">
            <template v-if="!loadingTicket && hasPermission">
              <span class="si-overview__badge-tag" v-if="yongsinLogData?.expiryDate">
                {{ dDay }}
              </span>
              <span class="si-overview__badge-tag" v-else>소장용</span>
              <span class="si-overview__badge-date" v-if="yongsinLogData?.expiryDate">
                ~ {{ yongsinLogData?.expiryDate }} 까지
              </span>
            </template>

            <template v-if="!loadingTicket && !hasPermission">
              <span class="si-overview__badge-tag">구매 후 이용가능</span>
            </template>
          </div>
        </div>

        <div class="si-overview__img">
          <img src="@manseImages/youngsin_left_img.png" alt="yongsin-left-img" />
        </div>
      </div>
    </div>
    <div class="si-overview__toc">
      <div class="si-overview__toc-title">목차</div>
      <div class="si-overview__toc-list">
        <button
          v-for="(item, idx) in yongsinContentList"
          :key="idx"
          class="si-overview__toc-item"
          :class="{ 'si-overview__toc-item--locked': !hasPermission }"
          @click="goToChildMenu(idx)"
        >
          {{ item.label }}
          <div class="si-overview__toc-icon">
            <IconArrow08 />
          </div>
        </button>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
@import '@/assets/nangman_style/_saju-insight-overview.scss';
</style>
